// extracted by mini-css-extract-plugin
export default {"wrapper":"LoadingSpinner_wrapper__NdicL","fullScreen":"LoadingSpinner_fullScreen__6NYdg","helperText":"LoadingSpinner_helperText__rfs2P"};